import * as Types from "@clockwise/schema";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type LoginMicrosoftUserMutationVariables = Types.Exact<{
  microsoftAuthCode: Types.Scalars["String"];
  redirectUri: Types.Scalars["String"];
}>;

export type LoginMicrosoftUserMutation = {
  __typename: "Mutation";
  loginMicrosoftUser: {
    __typename: "LoginMicrosoftUserMutationPayload";
    clientMutationId: string | null;
    verifyCodeResult: boolean | null;
    verifyCodeMessage: string | null;
    loginStatus: Types.LoginStatus;
    operation: Types.RefreshTokenResultOperationEnum | null;
    orgOperation: Types.OrganizationOperationResultEnum | null;
    viewer: {
      __typename: "Viewer";
      id: string;
      user: {
        __typename: "User";
        id: string;
        status: Types.UserStatusEnum | null;
        emails: Array<string>;
        givenName: string | null;
        familyName: string | null;
        externalImageUrl: string | null;
        createdTime: any | null;
        members: Array<{
          __typename: "Urn";
          value: string | null;
          scope: { __typename: "Urn"; type: Types.UrnType | null; value: string | null } | null;
        } | null> | null;
        orgs: {
          __typename: "OrgConnection";
          edges: Array<{
            __typename: "OrgEdge";
            node: {
              __typename: "Org";
              primaryOrgCalendar: string;
              primaryOrgEmail: string;
              id: string;
              experiments: Array<string | null> | null;
              name: string | null;
              createdTime: any | null;
              userPerson:
                | { __typename: "GraphEntityError" }
                | {
                    __typename: "Person";
                    profile: {
                      __typename: "UserProfile";
                      givenName: string | null;
                      familyName: string | null;
                      externalImageUrl: string | null;
                    } | null;
                  }
                | null;
              flowStates: {
                __typename: "FlowStateConnection";
                edges: Array<{
                  __typename: "FlowStateEdge";
                  node: {
                    __typename: "FlowState";
                    flowKey: string | null;
                    current: {
                      __typename: "FlowStatus";
                      state: string | null;
                      percentComplete: number | null;
                      errorMessage: string | null;
                    } | null;
                    pending: {
                      __typename: "FlowStatus";
                      state: string | null;
                      percentComplete: number | null;
                      errorMessage: string | null;
                    } | null;
                  } | null;
                } | null> | null;
              } | null;
              workingGroups: {
                __typename: "WorkingGroupConnection";
                edges: Array<{
                  __typename: "WorkingGroupEdge";
                  node: { __typename: "WorkingGroup"; id: string } | null;
                } | null> | null;
              };
            } | null;
          } | null> | null;
        };
      } | null;
    } | null;
  } | null;
};

export const LoginMicrosoftUserDocument = ({
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LoginMicrosoftUser" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "microsoftAuthCode" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "redirectUri" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "loginMicrosoftUser" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "microsoftAuthCode" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "microsoftAuthCode" },
                      },
                    },
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "redirectUri" },
                      value: { kind: "Variable", name: { kind: "Name", value: "redirectUri" } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "clientMutationId" } },
                { kind: "Field", name: { kind: "Name", value: "verifyCodeResult" } },
                { kind: "Field", name: { kind: "Name", value: "verifyCodeMessage" } },
                { kind: "Field", name: { kind: "Name", value: "loginStatus" } },
                { kind: "Field", name: { kind: "Name", value: "operation" } },
                { kind: "Field", name: { kind: "Name", value: "orgOperation" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "viewer" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "id" } },
                            { kind: "Field", name: { kind: "Name", value: "status" } },
                            { kind: "Field", name: { kind: "Name", value: "emails" } },
                            { kind: "Field", name: { kind: "Name", value: "givenName" } },
                            { kind: "Field", name: { kind: "Name", value: "familyName" } },
                            { kind: "Field", name: { kind: "Name", value: "externalImageUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "createdTime" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "members" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  { kind: "Field", name: { kind: "Name", value: "value" } },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "scope" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        { kind: "Field", name: { kind: "Name", value: "type" } },
                                        { kind: "Field", name: { kind: "Name", value: "value" } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "orgs" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: { kind: "Name", value: "first" },
                                  value: { kind: "IntValue", value: "1000000" },
                                },
                              ],
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "edges" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "node" },
                                          selectionSet: {
                                            kind: "SelectionSet",
                                            selections: [
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "primaryOrgCalendar" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "primaryOrgEmail" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "id" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "experiments" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "name" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "createdTime" },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "userPerson" },
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "InlineFragment",
                                                      typeCondition: {
                                                        kind: "NamedType",
                                                        name: { kind: "Name", value: "Person" },
                                                      },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: {
                                                              kind: "Name",
                                                              value: "profile",
                                                            },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "givenName",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "familyName",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "externalImageUrl",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "flowStates" },
                                                arguments: [
                                                  {
                                                    kind: "Argument",
                                                    name: { kind: "Name", value: "first" },
                                                    value: { kind: "IntValue", value: "1000000" },
                                                  },
                                                ],
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "edges" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "node" },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "flowKey",
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "current",
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "state",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "percentComplete",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "errorMessage",
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "pending",
                                                                  },
                                                                  selectionSet: {
                                                                    kind: "SelectionSet",
                                                                    selections: [
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "state",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "percentComplete",
                                                                        },
                                                                      },
                                                                      {
                                                                        kind: "Field",
                                                                        name: {
                                                                          kind: "Name",
                                                                          value: "errorMessage",
                                                                        },
                                                                      },
                                                                    ],
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: "Field",
                                                name: { kind: "Name", value: "workingGroups" },
                                                arguments: [
                                                  {
                                                    kind: "Argument",
                                                    name: { kind: "Name", value: "first" },
                                                    value: { kind: "IntValue", value: "1000000" },
                                                  },
                                                ],
                                                selectionSet: {
                                                  kind: "SelectionSet",
                                                  selections: [
                                                    {
                                                      kind: "Field",
                                                      name: { kind: "Name", value: "edges" },
                                                      selectionSet: {
                                                        kind: "SelectionSet",
                                                        selections: [
                                                          {
                                                            kind: "Field",
                                                            name: { kind: "Name", value: "node" },
                                                            selectionSet: {
                                                              kind: "SelectionSet",
                                                              selections: [
                                                                {
                                                                  kind: "Field",
                                                                  name: {
                                                                    kind: "Name",
                                                                    value: "id",
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown) as DocumentNode<LoginMicrosoftUserMutation, LoginMicrosoftUserMutationVariables>;
